import segregationTrip from '../components/views/segregationPlantTrip/segregationTrip.vue'
import createSegregationTrip from '../components/views/segregationPlantTrip/createSegregationTrip.vue'

const routes = [
    {
        path: 'segregationTrip',
        component: segregationTrip,
        name: 'segregationTrip',
        meta: {
            description: '',
            title: 'Segregation Plant Trip',
            requiresAuth: true
        }
    },
    {
        path: 'segregationTrip/createSegregationTrip',
        component: createSegregationTrip,
        name: 'createSegregationTrip',
        meta: {
            description: '',
            title: 'Add SegregationTrip',
            requiresAuth: true
        }
    },
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/segregationPlantTrip.route.js